// 中文翻译
export default {
  app: { name: '朋际', slogan: '只给真正亲近的人', loading: '加载中...' },
  nav: { circles: '圈层', chats: '聊天', friends: '好友', me: '我的', federal: '联邦' },
  home: {
    welcome: '欢迎来到朋际',
    myCircles: '我的圈层',
    recentMessages: '最近消息',
    noMessages: '暂无消息',
    noCircles: '创建你的第一个圈层，邀请最亲近的人',
    createCircle: '创建圈层',
    quickActions: { groupChat: '群聊', moments: '动态', lists: '清单', polls: '投票' },
    members: '位成员',
    crossCirclePeople: '跨圈层关系人',
    digitalHealth: '数字健康',
  },
  digitalHealth: {
    title: '数字健康',
    today: '今日使用',
    thisWeek: '本周使用',
    focusMode: '深度专注模式',
    focusModeDesc: '定时锁定应用，阻断非紧急通知',
    startFocus: '开始专注',
    stopFocus: '结束专注',
    dailyLimit: '每日使用上限',
    unlimited: '无限制',
    toolPhilosophy: '朋际是工具，不是目的地。用完即走，回归真实生活。',
    minutes: '分钟',
  },
  safetyNumber: {
    title: '验证安全号码',
    description: '比对安全号码，防止中间人攻击',
    verified: '已验证',
    keyChanged: '密钥已变更',
    step1: '复制安全号码，通过其他安全渠道发送给对方',
    step2: '请对方在自己的设备上查看安全号码',
    step3: '比对两边的号码是否完全一致',
    match: '号码一致',
    notMatch: '不一致',
    verifiedMessage: '身份已验证，通信受到端到端加密保护',
    techDetail: '安全号码由公钥哈希生成，类似 Signal 验证机制',
  },
  widgetPrivacy: {
    hidden: '完全隐藏',
    blurred: '模糊显示',
    normal: '正常显示',
    unlockPrompt: '点击解锁查看',
    bioAuth: '需要生物识别验证',
    tapToUnlock: '轻触以生物识别解锁',
    unlocked: '已解锁',
    autoLock: '内容将在30秒后自动锁定',
    lock: '锁定',
    localOnly: '生物特征数据仅存储在本地设备，不会上传',
  },
  wechatImport: {
    title: '微信聊天记录导入',
    guide: '迁移指南',
    importTab: '导入记录',
    progressiveMigration: '渐进式迁移',
    progressiveDesc: '微信是客厅，朋际是卧室——两者可以共存。按风险从低到高逐步迁移。',
    taziStep: '搭子约局',
    taziDesc: '把约饭、运动、出行计划迁移到朋际',
    familyStep: '家庭晒娃',
    familyDesc: '把孩子的照片、家庭趣事迁移到家人圈层',
    bestieStep: '密友聊天',
    bestieDesc: '把闺蜜/兄弟的私密对话迁移到密友圈层',
    lowRisk: '低',
    mediumRisk: '中',
    highRisk: '高',
    selectFile: '点击选择微信聊天记录文件',
    fileFormats: '支持 .txt .json .html .csv 格式，最大 200MB',
    parsing: '解析中...',
    parseComplete: '解析完成',
    totalMessages: '总消息数',
    importable: '可导入',
    skipped: '已跳过',
    preview: '消息预览',
    confirmImport: '确认导入',
    importSuccess: '聊天记录已安全导入！',
    howToExport: '如何在微信中导出聊天记录',
    exportStep1: '打开微信 → 进入想导出的聊天 → 点击右上角 ···',
    exportStep2: '选择「聊天记录迁移与备份」',
    exportStep3: '选择「备份到电脑」或「导出聊天记录」',
    exportStep4: '将导出的 .txt 或 .json 文件保存到手机',
    exportStep5: '回到朋际，选择文件导入',
    securityNote: '导入后的安全保证',
    securityDesc: '导入的聊天记录会立即进行 E2EE 加密。服务器无法读取内容。你可以随时删除导入的数据。',
    coexistence: '不是替代，是互补。朋际是你微信之外的私密空间。',
  },
  chat: {
    title: '聊天',
    placeholder: '发消息...',
    circlePlaceholder: '发消息到圈层...',
    emptyPrivate: '开始你们的私密对话',
    emptyCircle: '暂无消息，开始聊天吧',
    typing: '正在输入...',
    online: '在线',
    connecting: '连接中...',
    voiceCall: '语音通话',
    videoCall: '视频通话',
    sendFile: '发送文件',
    voiceMsg: '语音消息',
    emoji: '表情',
    send: '发送消息',
    clearChat: '清除记录',
    clearConfirm: '确定要清除所有聊天记录吗？此操作不可撤销。',
    uploadLimit: '文件大小不能超过100MB',
    uploadFailed: '上传失败',
    revoke: '撤回',
    revokeConfirm: '确定要撤回这条消息吗？（2分钟内可撤回）',
    revoked: '消息已被撤回',
  },
  messages: {
    title: '消息',
    noChats: '暂无消息',
    noChatsHint: '添加好友后开始聊天',
    calls: '通话记录',
    noCalls: '暂无通话记录',
    noCallsHint: '与好友开始加密通话',
    clearHistory: '清除通话记录',
    groupChat: '群聊',
    privateChat: '私聊',
  },
  friends: {
    title: '好友',
    addFriend: '添加好友',
    myFriends: '我的好友',
    noFriends: '还没有好友',
    noFriendsHint: '点击右上角添加好友',
    pending: '待处理请求',
    accept: '接受',
    reject: '拒绝',
    remove: '删除好友',
    removeConfirm: '确定删除好友？',
    searchLabel: '好友用户名',
    searchPlaceholder: '输入用户名搜索',
    search: '搜索',
    searching: '搜索中...',
    notFound: '未找到该用户，请确认用户名正确',
    searchTip: '朋际只能通过用户名精确搜索添加好友，不支持陌生人推荐。',
    inviteLink: '或通过邀请链接添加',
    copyInvite: '复制邀请链接',
    inviteCopied: '邀请链接已复制',
    added: '已添加为好友',
    removed: '已删除好友',
  },
  profile: {
    title: '我的',
    edit: '编辑',
    save: '保存',
    cancel: '取消',
    appearance: '外观',
    darkMode: '暗色模式',
    e2ee: '加密与安全',
    myKeys: '我的加密密钥',
    keyInfo: '私钥仅存储在您的设备上，从未离开',
    watermark: '聊天水印保护',
    watermarkOn: '水印保护已开启',
    watermarkOff: '水印保护已关闭',
    dataSovereignty: '数据主权',
    exportData: '导出我的全部数据',
    exporting: '导出中...',
    exportHistory: '导出历史',
    noExports: '暂无导出记录',
    deleteAccount: '永久删除账号',
    deleteWarning: '此操作不可撤销！',
    invite: '邀请好友',
    widget: '桌面Widget互动',
    logout: '退出登录',
    logoutConfirm: '确定退出登录？',
    updated: '已更新',
    bio: '个性签名',
    emptyBio: '这个人很懒，什么都没写',
  },
  login: {
    // 手机号 + 短信验证码登录已于 2026-10 整体退役，改成用户名 + 密码。
    // 旧的 phone/code/sendCode 系列键一并删除：留着一个没人用的键，
    // 下一个人会以为那条路还在。
    title: '用户名登录 / 注册',
    usernamePlaceholder: '用户名',
    passwordPlaceholder: '密码',
    passwordAgainPlaceholder: '再输一次密码',
    nicknamePlaceholder: '昵称（可选）',
    loginTab: '登录',
    registerTab: '注册',
    passwordTab: '账号密码',
    login: '登录',
    register: '创建账号',
    loggingIn: '登录中...',
    registering: '创建中...',
    usernameHint: '用户名 4-20 位，小写字母、数字或下划线，需含字母',
    passwordHint: '密码 8-64 位，不能是纯数字',
    passwordMismatch: '两次输入的密码不一致',
    forgot: '忘记密码？',
    trustDevice: '本地身份登录',
    agreement: '登录即表示同意朋际的隐私政策和用户协议',
    loginError: '登录流程出错，请重试',
    // 首登强制改密（迁移来的老账号拿着临时密码进来）
    mustChangeTitle: '先给账号设个新密码',
    mustChangeBlurb: '你的账号是从旧版迁移过来的，现在用的是一串临时密码。为了账号安全，请设置一个只有你自己知道的新密码。',
    currentPasswordPlaceholder: '当前密码',
    newPasswordPlaceholder: '新密码',
    changePasswordSubmit: '保存新密码',
    changing: '保存中...',
    // 人工找回
    recoveryTitle: '找回密码',
    recoveryBlurb: '忘记密码请联系客服人工重置。留下用户名和联系方式，客服会核对身份后帮你重置。',
    recoveryContact: '怎么联系你（手机号 / 微信号）',
    recoveryNote: '补充说明（可选）',
    recoverySubmit: '提交找回申请',
    recoverySubmitting: '提交中...',
    recoveryDone: '申请已提交',
    recoveryDoneBlurb: '客服会尽快联系你核对身份，确认后帮你重置密码。请留意消息。',
  },
  e2ee: {
    active: '端到端加密',
    waiting: '等待密钥交换',
    encrypted: 'E2EE加密',
    secure: '消息将以端到端加密传输',
    safeTransport: '消息将安全传输',
    callEncrypted: '通话加密中',
  },
  common: {
    save: '保存',
    cancel: '取消',
    confirm: '确认',
    delete: '删除',
    loading: '加载中...',
    noData: '暂无数据',
    back: '返回',
    online: '在线',
    members: '位成员',
    membersInOnline: '人在线',
  },
  burn: { title: '阅后即焚', burned: '消息已焚毁' },
  call: {
    incoming: '邀请你视频通话',
    incomingAudio: '邀请你语音通话',
    incomingScreen: '邀请你屏幕共享',
    calling: '正在呼叫...',
    accept: '接听',
    reject: '拒绝接听',
    hangup: '挂断',
    mute: '静音',
    unmute: '取消静音',
    speaker: '扬声器',
    camera: '摄像头',
  },
  circle: {
    title: '圈层详情',
    notFound: '圈层不存在',
    members: '圈层成员',
    owner: '圈主',
    admin: '管理员',
    member: '成员',
    remove: '移除',
    removeConfirm: '确定移除此成员？',
    removed: '成员已移除',
    deleteCircle: '删除圈层',
    dangerZone: '危险操作',
    noDesc: '暂无描述',
    intimacy: '亲密度阶梯',
    applyUpgrade: '申请进入更亲密圈层',
    pendingApply: '申请审批中',
    approve: '批准',
    defer: '暂缓',
  },
  polls: {
    title: '投票',
    createPoll: '发起投票',
    noPolls: '暂无投票',
    noPollsHint: '发起投票，一起决定吃饭/电影/地点',
    pollTitle: '投票标题',
    options: '选项',
    addOption: '添加选项',
    allowMultiple: '允许多选',
    create: '发起投票',
    created: '投票已创建',
    closed: '投票已关闭',
    active: '进行中',
    single: '单选',
    multi: '多选',
    voted: '投票成功',
    voters: '投票人',
    closePoll: '关闭投票',
    fillAll: '请填写完整信息',
  },
  moments: {
    title: '圈层动态',
    noMoments: '暂无动态',
    noMomentsHint: '发布第一条圈层动态吧',
    post: '发布',
    posting: '发布中...',
    publish: '发布动态',
    compose: '发布动态',
    placeholder: '分享你的想法...',
    anonymous: '匿名发布',
    anonymousOn: '匿名中',
    screenshotProtect: '防截图',
    screenshotOn: '已保护',
    permanent: '永久',
    burn1h: '1小时后消失',
    burn24h: '24小时后消失',
    burn72h: '3天后消失',
    posted: '发布成功',
  },
  album: {
    title: '圈层相册',
    privateTitle: '聊天图片',
    noPhotos: '暂无照片或视频',
    noPhotosHint: '聊天中发送的图片和视频会自动汇集到这里',
    photos: '照片',
    videos: '视频',
    all: '全部',
    loadMore: '加载更多',
    gridView: '网格视图',
    listView: '列表视图',
    screenshotProtected: '防截图保护',
  },
  sharedList: {
    title: '共享清单',
    newList: '新建',
    noLists: '暂无共享清单',
    noListsHint: '创建清单，和圈层好友一起协作',
    listName: '清单名称',
    listType: '清单类型',
    create: '创建',
    created: '清单已创建',
    deleted: '清单已删除',
    deleteConfirm: '确定删除此清单？',
    addItem: '添加新项目...',
    add: '添加',
    noItems: '暂无项目，添加第一个吧',
    creator: '创建者',
    archived: '已归档',
    deleteItem: '删除此清单',
    checklist: '通用清单',
    shopping: '采购清单',
    travel: '出行计划',
    bill: '账单分摊',
    care: '照护协同',
  },
  widget: {
    title: '桌面Widget',
    subtitle: '轻量互动 · 随手拍图推送到好友桌面',
    pushWidget: '推送Widget',
    pushHint: '随手拍一张图或写一句话，推送到对方手机桌面',
    selectFriend: '选择好友并发送',
    toFriend: '给好友发点什么...',
    send: '发送',
    sending: '发送中...',
    cancel: '取消',
    noFriends: '暂无好友，先添加好友吧',
    received: '收到的Widget',
    noReceived: '暂无收到的Widget',
    sent: '已发送的Widget',
    noSent: '暂无发送记录',
    sentTo: '发送给',
    pushed: 'Widget已推送！',
  },
  decentralized: {
    title: '节点与备份',
    ipfs: 'IPFS 存储',
    federation: '联邦网络',
    matrix: 'Matrix 桥接',
    nodeStatus: '节点状态',
    running: '运行中',
    offline: '离线',
    peerId: 'Peer ID',
    peerCount: '连接节点数',
    storagePath: '存储路径',
    uploading: '上传中...',
    uploadToIPFS: '上传到 IPFS',
    uploadHint: '点击或拖拽文件到此处',
    maxSize: '最大 100MB',
    textAttestation: '文本存证',
    attestPlaceholder: '输入要存证的文本...',
    attestUpload: '上链存证',
    uploaded: '上传成功',
    uploadFailed: 'IPFS 上传失败',
    localNode: '本节点',
    serverName: '服务器名称',
    serverId: '服务器 ID',
    knownNodes: '已知节点',
    fedNodes: '联邦节点',
    noFedNodes: '暂无已知联邦节点',
    addNode: '添加节点',
    connect: '连接',
    crossSearch: '跨服务器搜索',
    searchPlaceholder: '用户名 或 @user:server',
    search: '搜索',
    noResults: '未找到用户',
    sendMessage: '发送消息',
    matrixComing: 'Matrix 桥接即将上线',
    matrixDesc: '通过 Matrix 协议，朋际将与全球去中心化通信网络互联互通。',
    plannedFeatures: '计划功能',
  },
  invite: {
    title: '邀请好友',
    myCode: '我的邀请码',
    copyLink: '复制邀请链接',
    copied: '邀请链接已复制到剪贴板',
    shareWechat: '请分享到微信好友或群聊',
    unlockTitle: '邀请好友，解锁更多功能',
    howToUse: '使用方式',
    step1: '复制邀请码或分享链接给好友',
    step2: '好友下载朋际App，输入邀请码注册',
    step3: '双方自动成为好友，解锁圈层功能',
  },
};
